module.exports = __webpack_public_path__ + "static/media/1080X1080 HOME-PLATILLOS-SALSAS_50.8f712dfd.webp";